import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringIsEmptyExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringIsEmptyExpression";

export class StringIsEmptyExpressionEditor extends ExpressionRuleEditor<StringIsEmptyExpression> {
    render() {
        return (
            <>
                <ExpressionPiece>
                    <BracketedDiv>
                        <ExpressionValueRenderer el={this.ruleData!.value1!} />
                    </BracketedDiv>
                    <ExpressionPiece>is empty</ExpressionPiece>
                </ExpressionPiece>
            </>
        );
    }
}
